import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ColorPickerModule as NgxColorPicker } from '@iplab/ngx-color-picker';
import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ChromePickerSelectorComponent } from './chrome-picker-selector.component';
import { ChromePickerStylesDirective } from './chrome-picker-styles.directive';

@NgModule({
    declarations: [ChromePickerSelectorComponent, ChromePickerStylesDirective],
    imports: [CommonModule, NgxColorPicker, TwcModule, TranslateModule],
    exports: [ChromePickerSelectorComponent],
})
export class ChromePickerSelectorModule {}
